export class staticRoles {
    public static get Student(): string {
        return "Estudante";
      }
    public static get Teacher(): string {
        return "Docente";
      }
    public static get Admin(): string {
        return "Administrador";
      }
}
export const getAllStaticRoles = () => [staticRoles.Student, staticRoles.Teacher, staticRoles.Admin];
export const getRolesExpectStudentAndTeacher = () => [staticRoles.Student, staticRoles.Teacher];




